import { TenantSlug } from "../../sharedConfig.mjs";
import { CredentialVendor } from "../../credentialVendor.mjs";
import { hhbClinicConfig } from "./clinic.mjs";
import { hhbProviderRoster } from "./roster.mjs";
import { hhbProviderRouting } from "./routing.mjs";

//#region src/tenants/hhb/index.ts
/**
* Azalea is HHB's only live EHR. Availity, UHC, and Spruce are live too — those are
* payer portals and messaging, not EHRs.
*
* Athena was dropped on 2026-08-21. HHB moved its clinics to Azalea, but the pull
* schedulers are per vendor rather than per tenant, so every Athena tick walked HHB too
* and tried to log into an instance nobody uses (35 errored pull jobs through
* 2026-08-03). Resuming that scheduler for Skylight would have resumed those. The
* manifest is what makes a vendor live, so removing it here fails every HHB Athena path
* closed on its own: `getVendorSecret` refuses undeclared vendors. The `hhb-athena-*`
* secrets and HHB's `Athenahealth` EHR connection row are deliberately left in place —
* `async_jobs` history references that row, and the departments hanging off it still
* hold open tasks.
*
* ECW went the same way on 2026-09-18, and its code was deleted on 2026-10-26. Its
* secrets and connection row stay, as Athena's did.
*/
const hhb = {
	slug: TenantSlug.HHB,
	displayName: "Hamilton Health Box",
	vendors: [
		CredentialVendor.Availity,
		CredentialVendor.Azalea,
		CredentialVendor.UHC,
		CredentialVendor.Spruce
	],
	libretto: { workflows: {
		pullReferrals: { Azalea: "hhbAzaleaPullOpenReferrals" },
		sendReferral: { Azalea: "hhbAzaleaAttachRecordsSendReferral" },
		checkEligibility: {
			availity: "hhbAvailityCheckEligibility",
			uhc: "hhbUhcCheckEligibility"
		},
		submitPriorAuth: {
			availity: "hhbAvailitySubmitPriorAuth",
			uhc: "hhbUhcSubmitPriorAuth"
		},
		recordPatientConsent: {}
	} },
	clinic: hhbClinicConfig,
	routing: hhbProviderRouting,
	providerRoster: hhbProviderRoster,
	autoAssignReferralsToAgent: true,
	residentialProxy: {
		country: "US",
		state: "TX",
		city: "dallas"
	},
	auth: {
		sso: [{
			provider: "microsoft",
			providerId: "hhb-microsoft"
		}],
		password: false
	},
	spruce: {
		orgId: "entity_274QTQGC1CO00",
		departmentEndpoints: {
			Marfa: "ZW50aXR5XzI3NFFUUUdDMUNPMDA6KzE0MzI3MjkzMDAwOnBob25l",
			Presidio: "ZW50aXR5XzI3NFFUUUdDMUNPMDA6KzE0MzIyODk2MzU2OnBob25l",
			Pecos: "ZW50aXR5XzI3NFFUUUdDMUNPMDA6KzE0MzIzMDI0MDYxOnBob25l",
			Terlingua: "ZW50aXR5XzI3NFFUUUdDMUNPMDA6KzE0MzIzMDA1MTc1OnBob25l",
			"Bravo Health Marfa (Azalea)": "ZW50aXR5XzI3NFFUUUdDMUNPMDA6KzE0MzI3MjkzMDAwOnBob25l",
			"Bravo Health Pecos (Azalea)": "ZW50aXR5XzI3NFFUUUdDMUNPMDA6KzE0MzIzMDI0MDYxOnBob25l",
			"Bravo Health Presidio Clinic (Azalea)": "ZW50aXR5XzI3NFFUUUdDMUNPMDA6KzE0MzIyODk2MzU2OnBob25l",
			"Bravo Health Terlingua Clinic (Azalea)": "ZW50aXR5XzI3NFFUUUdDMUNPMDA6KzE0MzIzMDA1MTc1OnBob25l"
		}
	}
};

//#endregion
export { hhb };